module.exports = __webpack_public_path__ + "img/filter-inserter-platform.51a1ba08.png";